import React from 'react';
import HeaderCarousels from '../components/HeaderCarousels';
import JusticeSvg from "../assets/justice-svg.svg";
import WelcomeImage1 from '../assets/welcome_image-1.png'
import WelcomeImage2 from '../assets/welcome_image-2.png'
import PencilSvg from '../assets/pencil.svg';
import ConnectingSvg from '../assets/connecting.svg';
import ExchangeSvg from '../assets/exchange.svg';
import DocumentSvg from '../assets/document.svg';
import ClientImage1 from '../assets/client_services-1.png'
import ClientImage2 from '../assets/client_services-2.png'
import ClientImage3 from '../assets/client_services-3.png'
import ClientImage4 from '../assets/client_services-4.png'
import ClientImage5 from '../assets/client_services-5.png'
import ClientImage6 from '../assets/client_services-6.png'
import ClientImage7 from '../assets/client_services-7.png'
import ImportanceBackground from '../assets/importance-bg.png'
import LawyerServiceCard from '../components/LawyerServiceCard';
import ServiceCard from '../components/ServiceCard';
import ReactPlayer from 'react-player'; //https://www.npmjs.com/package/react-player
import TestimonialsPerson1 from '../assets/testimonials_person-1.png';
import TestimonialsPerson2 from '../assets/testimonials_person-2.png';
import TestimonialsPerson3 from '../assets/testimonials_person-3.png';
import '../styles/HomePage.css';
import "../styles/Welcome.css";
import "../styles/HomePageServices.css";
import '../styles/Testimonials.css'
import '../styles/Importance.css';
import { Link } from 'react-router-dom';
import TestimonialsCard from '../components/TestimonialsCard';

const HomePage = () => {
    const lawyerServicesData = [
        { url: PencilSvg, title: 'Data Entry Services' },
        { url: ConnectingSvg, title: 'Worldwide Client Acquisition & Business Development' },
        { url: ExchangeSvg, title: 'Asylum Statement & Legal Documents Translation' },
        { url: DocumentSvg, title: 'Legal Forms/Document Filing Assistance' }];
    const clientServicesData = [
        { url: ClientImage1, title: 'Legal Forms/Document Filing Assistance' },
        { url: ClientImage2, title: 'Asylum Application Filing Assistance' },
        { url: ClientImage3, title: 'Asylum Statement & Legal Documents Translation' },
        { url: ClientImage4, title: 'Work Permit & Social Security Number Application Assistance' },
        { url: ClientImage5, title: 'Easy & Attractive Payment Plans For Our Services' },
        { url: ClientImage6, title: 'Indian Passport Application (New/ Renewal) Services' },
        { url: ClientImage7, title: 'Tax Identification Number (Tin) Application Assistance' }];
    const VideoPath = 'https://www.youtube.com/watch?v=QCw4RiWQA_E';
    const testimonialsData = [
        { url: TestimonialsPerson1, name: 'Sandra Payne', content: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.', },
        { url: TestimonialsPerson2, name: 'Deo John', content: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.', },
        { url: TestimonialsPerson3, name: 'Douglas Ray', content: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.', }];
    return (
        <>
            <HeaderCarousels />
            <main>
                <div className="welcome_wrapper">
                    <section className="welcome">
                        <h1 className="welcome_title">Welcome to Amderon</h1>
                        <img src={JusticeSvg} alt="Justice SVG" className="welcome_svg" />
                        <p className="welcome_para welcome_para-1">
                            Amderon Inc. was establised in 2017 in Chicago, IL with the view of
                            providing services and support to immigrants and their families. We
                            started as a small setup providing services like transportation,
                            translation, consultancy, etc. to immigrants who were unaware of local
                            laws, rules and language. Our team is multilingual with expertise in
                            Hindi, Gujarati, Konkani, Pashto, Urdu, English, etc. and this has
                            greatly helped us in connecting with our clients and putting them at
                            ease.
                        </p>
                        <img src={WelcomeImage1} alt="" className="welcome_image welcome_image-1" />
                        <img src={WelcomeImage2} alt="" className="welcome_image welcome_image-2" />
                        <p className="welcome_para welcome_para-2">
                            Since it's inception, Amderon Inc. has been committed to serving our
                            clients in an empathetic manner and we believe in conducting our
                            business with the highest moral and ethical standards. This approach
                            led us to gain more clients over the years through word-of-mouth
                            publicity. The confidence showed by our clients in us gave us the
                            impetus to expand our services.
                        </p>
                    </section>
                </div>
                <section className="homepage_services">
                    <article className="lawyer_services-wrapper">
                        <div className="row">
                            <div className="lawyer_services">
                                <h1 className="lawyer_services-title">Services For Lawyers</h1>
                                <p className="lawyer_services-para">We provide various services for lawyers.</p>
                                <div className="lawyer_services-cards">
                                    {
                                        lawyerServicesData.map((service, index) => {
                                            return (
                                                <LawyerServiceCard service={service} key={index} />
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </article>
                    <article className="client_services-wrapper">
                        <div className="row">
                            <div className="client_services">
                                <h1 className="client_services-title">Services For Clients</h1>
                                <p className="client_services-para">We provide various services for clients.</p>
                                <div className="services-cards">
                                    {
                                        clientServicesData.map((service, index) => {
                                            return (
                                                <ServiceCard service={service} key={index} />
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </article>
                </section>
                <section className='importance'>
                    <img src={ImportanceBackground} alt="" className="importance_image" />
                    <div className="importance_absolute">
                        <div className="importance_title-wrapper">
                            <h1 className="importance_title">Every Person Who Walks Through Our Door Is Important To Us.</h1>
                        </div>
                        <div className="row">
                            <div className="importance_content">
                                <h1 className="importance_content-title">Committed to Helping Our Clients Succeed.</h1>
                                <p className="importance_content-para">Lorem Ipsum is simply dummy text of the printing and
                                    typesetting industry.</p>
                                <Link to='/contact' className='importance_content-link'>Free Evaluation</Link>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='testimonials' >
                    <div className="row">
                        <h1 className="testimonials_title">What Our Clients Say</h1>
                        <div className="testimonials_content">
                            <article className="testimonials_video-wrapper">
                                <ReactPlayer url={VideoPath} controls={true} className='testimonials_video' />
                                <div className="testimonials_video-content">
                                    <h2 className="testimonials_video-title">A Demo Interview Placeholder</h2>
                                    <p className="testimonials_video-para">Lorem Ipsum is simply dummy text
                                        of the printing and typesetting industry.</p>
                                </div>
                            </article>
                            <div className="testimonials_cards">
                                {
                                    testimonialsData.map((testimonial, index) => {
                                        return (
                                            <TestimonialsCard testimonial={testimonial} key={index} />
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </section >
            </main>
        </>
    );
}

export default HomePage;
